'use client';

import { bringSurvey, signinGuestUuid, signinWithZzimToken } from '@/utils/actions';
import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import { useAtom, useSetAtom } from 'jotai';
import { historyStackAtom } from '@/atom/historyStack';
import { history } from '@/utils/history';
import { confirmModalAtom } from '@/atom/modal';
import useGetAllSavedPoisQuery from '@/app/hooks/useGetAllSavedPoisQuery';

export default function ClientComponentInRoot({}: {}) {
  const router = useRouter();
  const pathname = usePathname();

  const [historyStack, setHistoryStack] = useAtom(historyStackAtom);
  const setConfirmModal = useSetAtom(confirmModalAtom);

  const [isFinishLoginCheck, setIsFinishLoginCheck] = useState(false);
  const [hasAccessToken, setHasAccessToken] = useState(false);

  const savedPois = useGetAllSavedPoisQuery();

  useEffect(() => {
    fetch('/api/loaded');
  }, []);

  useEffect(() => {
    signinGuestUuid();
  }, [pathname]);

  const checkAndSaveNeedSaveSurvey = useCallback(async () => {
    const needSaveSurveyString = sessionStorage.getItem('needSaveSurvey');
    try {
      if (!needSaveSurveyString) return;
      const needSaveSurvey: {
        surveyId: string;
        guestUuid: string;
      } = JSON.parse(needSaveSurveyString);
      if (needSaveSurvey?.surveyId && needSaveSurvey?.guestUuid) {
        sessionStorage.removeItem('needSaveSurvey');
        const bringSurveyRes = await bringSurvey(needSaveSurvey.surveyId, needSaveSurvey.guestUuid);
        if (bringSurveyRes?.id) {
          setConfirmModal({
            visible: true,
            title: '일정표를 확인하러 갈까요?',
            message: '저장한 일정표는\n나의 여행에서 확인할 수 있어요.',
            onConfirm: () => {
              setConfirmModal({ visible: false });
              router.push(`/trip/${bringSurveyRes.id}`, { scroll: false });
            },
            onClose: () => {
              setConfirmModal({ visible: false });
            },
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (isFinishLoginCheck) return;

    signinWithZzimToken().then((signinResult) => {
      setIsFinishLoginCheck(true);
      if (signinResult?.accessToken) {
        setHasAccessToken(true);
        checkAndSaveNeedSaveSurvey();
      }
    });
  }, []);

  useEffect(() => {
    const unlistenHistoryEvent = history?.listen(({ action }) => {
      if (action !== 'POP') return;
      console.log(`[client-component-in-root] history action: ${action}`);
      if (historyStack.length === 0) return;

      const { name, afterAction } = historyStack.pop()!;
      console.info(`[client-component-in-root] ${name} is popped`);
      afterAction?.();
      setHistoryStack([...historyStack]);
    });

    return unlistenHistoryEvent;
  }, [historyStack]);

  return null;
}
